var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartEl",staticClass:"fe-star-trend-chart",style:({ height: _vm.height })})
}
var staticRenderFns = []

export { render, staticRenderFns }